import * as React from 'react';
import { useSelector } from 'react-redux';

import { AgentHonest } from '../../../../../components/AuthorAsideNew';
import { selectAgentLevelInfo } from '../../../../../selectors';

export const AgentHonestContainer: React.FC = () => {
  const agentLevelInfo = useSelector(selectAgentLevelInfo);

  if (!agentLevelInfo?.levelOrder) {
    return null;
  }

  return <AgentHonest level={agentLevelInfo.levelOrder} />;
};
